module.exports = __webpack_public_path__ + "img/lens-167-plus-02.4f7934cd.png";